export function getdata() {
	var obj = {
		searchlist: [],
		tableData: [],
		searchdata: {},
		headData: [{
				title: "公司名称",
				prop: "gongsmc",
				width: 160,
				custom:true
			},
			{
				title: "份数",
				prop: "piaojzs",
				width: 80,
				AmountFormat: true,
				custom:true
			},
			{
				title: "金额",
				prop: "jine",
				width: 80,
				AmountFormat: true,
				custom:true
			},
			{
				title: "税额",
				prop: "shuie",
				width: 80,
				AmountFormat: true,
				custom:true
			},
		],
		outputData: {
			exportType: "",
			shenbq: "",
		},
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}
	}
	return obj
}
